/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getAccessToken, getCompanyToken } from "../../apis/auth";
import { taskRequest } from "../../utils/task";
import { each, get, isString } from "lodash";

// store
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { getUnreadNotificationCount, logoutUser, setProfile } from "../../store/actions";

// component
import Button from "../Button";
import Icon from "../Icon";
import { NoticeDetail } from "../Notice";
import TaskRequest from "../Task/TaskRequest";
import ContractRequest from "../Contract/ContractRequest";
import Loading from "../Loading";
import Alert from "../Alert";
import SearchEmployeePopup from "../Employee/SearchEmployeePopup";
import PreviewEmployee from "../Employee/PreviewEmployee";
import PreviewClient from "../Client/PreviewClient";
// icon
import PencilIcon from "../../assets/images/icon/pencil-icon.svg";
import { isAuthUrl } from "../../utils/route";
import { LOAD_OPEN_TASK_TYPE } from "../../constants/TASK";
import EmployeeDetail from "../Employee/EmployeeDetail";
import { MENUS, TAX_PORTAL_MENUS } from "../../constants/MENU";
import { dps, isEmpty } from "../../utils/lodashExtend";
import useInterval from "../../hooks/useInterval";
import EmployeeCardPurchaseList from "../Card/EmployeeCardPurchaseList";
import { isTestCompany } from "../../utils/auth";
import Consulting from "../Consulting/Consulting";
import consultingPopup from "../../utils/consulting";
import { classnames } from "../../utils/text";
import { TrialInfoModal } from "../Trial/TrialInfoModal";
import { TrialRequestPartners } from "../Trial/TrialRequestPartners";
import PrintPage from "../PrintPage";
import { decode } from "jsonwebtoken";
import PreviewCustodian from "../Custodian/PreviewCustodian";
import TaxAccountantUsefulSitePop from "../TaxAccountantUsefulSite/Popup";
import ChangePassword from "../ChangePassword";
import TaxCompanyScheduleDetail from "../TaxPortal/TaxDashboard/TaxCompanyScheduleDetail";
import systemAlert from "../../utils/systemAlert";
import PreviewExternalProfile from "../Employee/PreviewExternalProfile";
import PreviewAlarmSetting from "../AlarmSetting/PreviewAlarmSetting";

// import { searchEmployee } from "../../utils/employee";

const Common = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const {
    employee,
    user,
    permissions,
    role,
    alert,
    taxAccountantUsefulSite,
    printPage
  } = useSelector(
    (store) => ({
      ...store.Profile,
      printPage: store.Data.printPage,
      alert: store.Data.alert,
      user: store.Profile.user,
      employee: store.Profile.employee,
      role: store.Profile.role,
      permissions: store.Profile.permissions,
      taxAccountantUsefulSite: store.Data.taxAccountantUsefulSite
    }),
    shallowEqual
  );

  const storeProfile = useSelector((store) => store.Profile);
  const storeData = useSelector((store) => store.Data);
  const [taskPermission, setTaskPermission] = useState(null);
  const [isTaxPotal, setIsTaxPotal] = useState(false);
  const [isScheduleOpen, setIsScheduleOpen] = useState(false);

  useEffect(() => {
    let type = Number(get(role, 'type'));
    // 매니징 상태가 아닌데 매니저로 처리된경우
    if ([9, 3, 4].includes(type) && !storeProfile.isManaging) {
      type = 5;
    }

    each(MENUS, (menu) => {
      if (!isEmpty(menu.children)) {
        // 하위가 있는 메뉴
        menu.isHide = true;
        each(menu.children, (subMenu) => {
          if (!isEmpty(permissions)) {
            const target = permissions.find(p => p.code === subMenu.code);
            subMenu.isHide = !target || target.level === null || target.level === undefined;
          } else {
            subMenu.isHide = !subMenu.readTypes.includes(type);
          }
          if (!subMenu.isHide) {
            menu.isHide = false;
          }
        });
      } else {
        // 하위가 없는 메뉴
        if (!isEmpty(permissions)) {
          const target = permissions.find(p => p.code === menu.code);
          menu.isHide = !target || target.level === null || target.level === undefined;
        } else {
          menu.isHide = !menu.readTypes.includes(type);
        }
      }
    });

    if (!isEmpty(permissions)) {
      setTaskPermission(permissions.find(p => p.code === 'TODO'));
    }
  }, [permissions, role, storeProfile.isManaging]);



  useEffect(() => {
    console.log('taxAccountantUsefulSite : ', taxAccountantUsefulSite)
  }, [taxAccountantUsefulSite])


  
  const _taskRequest = (task) => {
    taskRequest(isString(task) ? task : null);
  };


  // 최초 실행
  useEffect(() => {
    console.log(`WeCake ver. ${process.env.REACT_APP_MODE}.${process.env.REACT_APP_VERSION}`);
    if (isTestCompany()) {
      console.log('체험용 회사입니다.');
    }
    const companyToken = getCompanyToken();
    // 로그인(회사 토큰, 유저정보) 정보 없는 경우 로그인 페이지로 이동

    if (!isAuthUrl(history.location.pathname)) {
      if (!companyToken || !getAccessToken()) {
        dispatch(logoutUser(history));
      } else {
        dispatch(setProfile());
      }
      if (process.env.REACT_APP_SUB_MODE === 'task' && LOAD_OPEN_TASK_TYPE) {
        _taskRequest(LOAD_OPEN_TASK_TYPE);
      }
    }
  }, []);

  useEffect(() => {
    if (user) {
      dispatch(getUnreadNotificationCount());
    }
  }, [user]);

  useInterval(() => {
    if (user) {
      dispatch(getUnreadNotificationCount());
    }
    // 1분마다 노티갱신
  }, 1000 * 60);

  // 10초마다 토큰 확인 및 새로고침
  useInterval(() => {
    const token = getCompanyToken();
    if (token) {
      const me = decode(token);
      if (me.companyIdx !== employee?.companyIdx) {
        window.location.reload();
      }
    }
  }, 1000 * 10);

  useEffect(() => {
    !isEmpty(pathname) &&
      setIsTaxPotal(
        !isEmpty(dps(TAX_PORTAL_MENUS, pathname, "children", "path"))
      );
  }, [pathname]);

  const openSchedule = () => {
    setIsScheduleOpen(true);
  };

  return (
    <>
      {user && (
        <>
          {/* Task */}
          <TaskRequest />
          {/* PrintPage */}
          {printPage && <PrintPage printPage={printPage} />}

          {/* Contract */}
          <ContractRequest />
          {isTaxPotal ? (
            <div className="request-button-wrap">
              <Button
                className="request-task-button print-out"
                action={openSchedule}
                label={
                  <>
                    <Icon src={PencilIcon} />
                    <br />
                    일정
                  </>
                }
              />
            </div>
          ) : (
            <div className={classnames("request-button-wrap", { disabled: (user.companyType === 1 && (user.type === 2 || user.type === 3 || user.type === 9)) || isEmpty(taskPermission) || (taskPermission && taskPermission.level < 2) })}>
              <Button
                className="request-task-button print-out"
                action={_taskRequest}
                disabled={(user.companyType === 1 && (user.type === 2 || user.type === 3 || user.type === 9)) || isEmpty(taskPermission) || (taskPermission && taskPermission.level < 2)}
                label={
                  <>
                    <Icon src={PencilIcon} />
                    <br />
                    할일
                  </>
                }
              />
              <div className="request-hover-description">
                할일 쓰기 권한이 없습니다.
              </div>
            </div>
          )}
          {/* Search Employee */}
          <SearchEmployeePopup />
          {/* Preview Employee */}
          <PreviewEmployee />
          {/* Employee Detail */}
          <EmployeeDetail />
          {/* Notice */}
          <NoticeDetail />
          <EmployeeCardPurchaseList />
          {/** Preview client */}
          <PreviewClient />
          {/* Priview taxpayer */}
          <PreviewCustodian />
          {/* Preview profile */}
          <PreviewExternalProfile />

          {/* preview alarm setting */}
          <PreviewAlarmSetting />

          {/* master password modal */}
          <ChangePassword />

          <TaxCompanyScheduleDetail
            managerCompany={{ companyIdx: user?.managerCompanyIdx }}
            schedule={{}}
            toggle={isScheduleOpen}
            setToggle={setIsScheduleOpen}
            formType={"create"}
            submit={() => {
              systemAlert('일정 등록이 완료되었습니다.\n확인을 위해 일정 페이지로 이동하시겠습니까?', {
                buttons: [
                  {
                    color: 'text',
                    label: '취소'
                  },
                  {
                    label: '이동',
                    onClick: () => {
                      pathname.startsWith("/tax-portal/schedules")
                        ? window.location.reload()
                        : history.push("/tax-portal/schedules");
                    }
                  }
                ]
              });
            }}
          />
        </>
      )};
      {storeData.isFullSizeLoading && <Loading isFull={true}>{isString(storeData.isFullSizeLoading) ? storeData.isFullSizeLoading : ''}</Loading>}
      <Alert isOpen={!!alert} {...alert} />
      <TrialInfoModal />
      <TrialRequestPartners />

      <Consulting
        setOpen={consultingPopup}
        open={storeData.isConsultingPopup}
      />

      <TaxAccountantUsefulSitePop isOpen={!!taxAccountantUsefulSite} />


    </>
  );
};
export default Common;
